import React from 'react'
import { Box, TextField, Typography } from '@mui/material';
import useEmailEditorStore from '../../utilities/emailEditorStore';
import TypographyProps from './common/TypographyProps';
import BlockProps from './common/BlockProps';

function HtmlBlockProperties({blockId}) {
    const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
        // Get the current block data from the store
        const block = getBlockById(blockId);
        
        if (!block) {
            return <Typography>Block not found</Typography>;
        }
        
        // Provide default properties if properties is undefined
        const properties = block.properties || {};

        // Generic property change handler
        const handlePropertyChange = (propertyName, value) => {
            updateBlockProperties(blockId, { [propertyName]: value });
        };
  return (
    <>
    <TextField
        fullWidth
        multiline
        rows={4}
        label="HTML Content"
        value={properties.htmlContent || ''}
        onChange={(e) => handlePropertyChange('htmlContent', e.target.value)}
        sx={{ mb: 2 }}
      />
      
      <Box>
       <TypographyProps properties={properties} onPropertyChange={handlePropertyChange} />
       <BlockProps properties={properties} onPropertyChange={handlePropertyChange} />
      </Box>
    </>
  )
}

export default HtmlBlockProperties